import ResumeQuantity from "../../components/resumeQuantity";
import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import SalesTrendChart from "../../components/SalesTrendChart";
import CustomDateRangePicker from "../../components/customDateRangePicker";
import { fetchPayments } from '../../apis/paymentsApi';

const Sales = () => {
  const [lastTotalAmount, setLastTotalAmount] = useState(0);
  const [currentRecords, setCurrentRecords] = useState([]);
  const [currentTotalAmount, setCurrentTotalAmount] = useState(0);

  const lastMonth = Moment().subtract(1, 'months').toDate();
  const [period, setPeriod] = useState();

  const calculateDateDifference = (startDate, endDate) => {
    const differenceInDays = Moment(endDate).diff(Moment(startDate), 'days');
    setPeriod(Math.abs(differenceInDays));
    return differenceInDays;
  };

  const fetchSales = async (startDate, endDate) => {
    const differenceInDays = calculateDateDifference(startDate, endDate);
    const differenceInMonths = Math.ceil(differenceInDays / 30);

    const { sales: currentRecords, totalAmount: currentTotalAmount } = await apiCall(startDate, endDate);
    setCurrentRecords(currentRecords);
    setCurrentTotalAmount(currentTotalAmount);

    const pastStartDate = Moment(startDate).subtract(differenceInMonths, 'months').toDate();
    const pastEndDate = Moment(endDate).subtract(differenceInMonths, 'months').toDate();
    const { totalAmount: lastTotalAmount } = await apiCall(pastStartDate, pastEndDate);
    setLastTotalAmount(lastTotalAmount);
  };

  const apiCall = async (startDate, endDate) => {
    const response = await fetchPayments(startDate, endDate);
    return {
      ...response,
      sales: response.sales.map(sale => ({
        ...sale,
        created_at: Moment(sale.created_at).format('YYYY-MM-DD'),
      })),
    };
  };

  useEffect(() => {
    fetchSales(lastMonth, new Date());
  }, []);

  const salesChange = lastTotalAmount
    ? currentTotalAmount / lastTotalAmount
    : 0;

  return (
    <>
      <CustomDateRangePicker onDateChange={fetchSales} />

      <div className="col-11 mx-auto d-flex justify-content-around shadow-lg p-3 mb-5 bg-body rounded">
        <ResumeQuantity
          title="Sales"
          symbol="$"
          amount={currentTotalAmount}
          proportionChange={salesChange}
          period={period}
          icon="money-recive.png"
          backgroundColor="bc-gp-secondary-light"
        />
      </div>

      <SalesTrendChart salesData={currentRecords} />
    </>
  );
};

export default Sales;
